import { styled, css } from '../../theming';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { ExpandedState } from './types';
import { Layout } from '../../Layout/Layout';
import { responsiveProp, ResponsiveProp } from '../../utils/responsiveProp';

const navExpanded = css`
  position: absolute;
  align-items: stretch;
  top: ${tokens.size.navBar.height};
  left: 0;
  min-height: calc(100% - ${tokens.size.navBar.height});
  padding: 0 16px 16px;
  width: 100%;
`;

type NavProps = Partial<ExpandedState> & {
  isVisible: ResponsiveProp<boolean>;
};

const Nav = styled(Layout)<NavProps>`
  ${({ isMobileMenuExpanded }) => isMobileMenuExpanded && navExpanded}
  ${({ isVisible }) => ({
    ...responsiveProp(isVisible, (isVisible) => ({
      display: isVisible ? 'flex' : 'none',
    })),
  })}

  @media (min-width: ${tokens.viewports.breakpoints.small}) {
    position: static;
    overflow: visible;
    height: auto;
    min-height: auto;
    padding: 0;
    justify-content: space-between;
  }
`;

export default Nav;
